import { getServiceName } from '@repo/utils';

import BubblechatPrivacyPolicy from './bubblechat'; // bubblechat 전용
import TinglePrivacyPolicy from './tingle'; // tingle 전용

const PrivacyPolicy = () => {
  const serviceName = getServiceName();
  if (serviceName === 'tingle') return <TinglePrivacyPolicy />;
  return <BubblechatPrivacyPolicy />;
};

export default PrivacyPolicy;
